import React, { useEffect } from 'react';









const COMPLETE_UPLOADING_VALUE = 100;
const FINALISING_UPLOADING_VALUE = 99;
const COMPLETE_DEFAULT_TEXT = 'Complete';
const FINALISING_DEFAULT_TEXT = 'Finalising';


function UploadPercent({
  items,
  onUpdateStatus,
  finalisingText = FINALISING_DEFAULT_TEXT,
  completeText = COMPLETE_DEFAULT_TEXT
}) {
  const getTotalValue = () => {
    let totalItemsLoadedSize = 0;
    let totalItemsSize = 0;

    items.forEach(({ loaded, totalSize }) => {
      totalItemsLoadedSize += loaded || 0;
      totalItemsSize += totalSize || 0;
    });

    return { totalItemsLoadedSize, totalItemsSize };
  };

  const getRoundedTotalValue = () => {
    const { totalItemsLoadedSize, totalItemsSize } = getTotalValue();
    const roundedTotalPercent = Math.floor(totalItemsLoadedSize / totalItemsSize * 100);

    return roundedTotalPercent;
  };

  const getTotalPercent = () => getRoundedTotalValue() ? `${getRoundedTotalValue()}%` : '';

  useEffect(() => {
    if (onUpdateStatus) {
      const isUploadingFinished = getRoundedTotalValue() === COMPLETE_UPLOADING_VALUE;
      const isUploading = Boolean(items.length && !isUploadingFinished);

      onUpdateStatus(isUploading);
    }
  }, [items]);

  if (getRoundedTotalValue() === FINALISING_UPLOADING_VALUE) {
    return finalisingText;
  }

  if (getRoundedTotalValue() === COMPLETE_UPLOADING_VALUE) {
    return completeText;
  }

  return <>{getTotalPercent()}</>;
}

export default UploadPercent;